import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ticket-sales',
  templateUrl: './ticket-sales.component.html',
  styleUrls: ['./ticket-sales.component.scss']
})
export class TicketSalesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
